var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"annual-reviews"},[_c('b-overlay',{attrs:{"show":_vm.loading}},[_c('b-alert',{attrs:{"variant":"primary","show":_vm.reviews.length === 0}},[_vm._v("No reviews have been recorded yet")]),_vm._l((_vm.reviews),function(review,i){return _c('PreviousReview',{key:i,attrs:{"review":review}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }